import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import {
  PLAGUE_220_SKULLS_IMAGE_SRC,
  PLAGUE_220_OPPONENT_GENERAL_DATA_ZONE,
} from '../config/plague220SkullsEffect';
import { getGeneralZoneRect } from '../utils/generalPortraitAnchor';
import './Plague220SkullsPortraitEffect.css';

function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * skulls.png centered on the opponent general portrait for 2 seconds (strategem 220 request).
 */
export function Plague220SkullsPortraitEffect({ generalDataZone = PLAGUE_220_OPPONENT_GENERAL_DATA_ZONE, animationKey }) {
  const [anchor, setAnchor] = useState(null);
  const reducedMotion = prefersReducedMotion();

  useLayoutEffect(() => {
    let cancelled = false;
    const measure = (attempt) => {
      if (!generalDataZone) {
        if (!cancelled) setAnchor(null);
        return;
      }
      const rect = getGeneralZoneRect(generalDataZone);
      if (rect) {
        if (!cancelled) {
          const size = Math.min(rect.width, rect.height) * 0.95;
          setAnchor({
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2,
            size,
          });
        }
        return;
      }
      if (attempt < 24 && !cancelled) {
        requestAnimationFrame(() => {
          if (!cancelled) measure(attempt + 1);
        });
      }
    };
    setAnchor(null);
    measure(0);
    return () => {
      cancelled = true;
    };
  }, [generalDataZone, animationKey]);

  if (!anchor) {
    return null;
  }

  const layer = (
    <div
      className={[
        'plague220-skulls-portrait-layer',
        reducedMotion ? 'plague220-skulls-portrait-layer--static' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden
      data-animation-key={animationKey}
    >
      <div
        className="plague220-skulls-portrait-root"
        style={{
          left: `${anchor.x}px`,
          top: `${anchor.y}px`,
          width: `${anchor.size}px`,
          height: `${anchor.size}px`,
        }}
      >
        <img
          className="plague220-skulls-portrait-img"
          src={PLAGUE_220_SKULLS_IMAGE_SRC}
          alt=""
          draggable={false}
        />
      </div>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(layer, document.body);
  }
  return layer;
}

export default Plague220SkullsPortraitEffect;
